@use "sass:map";
@import '../../styles/variables.scss';

.loaderWrapper {
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center; 
}